import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { adminAPIURL, customHeaders } from '../../../../../../Containers/Config/index.js';
import { APPROVAL_SURGE_FILE_UPLOAD, APPROVAL_SURGE_FILE_UPLOAD_SUCCESS, APPROVAL_SURGE_FILE_UPLOAD_ERROR } from '../../../actions.js';
import apiCall from '../../../../apiCall.js';

function* approveSurgeFileUpload({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const { fileUploadId, approvalType } = payload?.data;

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v1/surge-file-uploads/${fileUploadId}/${approvalType}`,
      method: 'POST',
      headers: {
        ...filteredHeaders,
      },
      data: payload?.data,
    });

    if (response.status === 200) {
      yield put({
        type: APPROVAL_SURGE_FILE_UPLOAD_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: APPROVAL_SURGE_FILE_UPLOAD_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: APPROVAL_SURGE_FILE_UPLOAD_ERROR, payload: error });
  }
}

export function* watchapproveSurgeFileUpload() {
  yield takeEvery(APPROVAL_SURGE_FILE_UPLOAD, approveSurgeFileUpload);
}

function* approveSurgeFileUploadSaga() {
  yield all([fork(watchapproveSurgeFileUpload)]);
}

export default approveSurgeFileUploadSaga;
